import React from 'react'

// Material-UI
import Button from '@mui/material/Button'

import './ButtonSave.scss'
import CircularProgress from '@mui/material/CircularProgress'

function ButtonSave({loading, className = 'submit-button',  onClickCallback, disabled, text, styles = { maxWidth: '200px', minWidth: '200px' } }) {
  let textBtnColor = disabled ? 'gray' : 'white'
  return (
    <div className="save-button-wrapper">
      <Button
        style={{...styles, color: textBtnColor}}
        variant="contained"
        disabled={disabled}
        color="primary"
        className={!loading ? className : "submit-button-disabled"}
        size="medium"
        onClick={onClickCallback}
      >
        {text? text:"Save"}
      </Button>
      {loading && <CircularProgress size={24} className="button-progress"/>}
    </div>
  )
}

export default ButtonSave
